export default {
  data() {
    return {
      entries: [],
    };
  },
  methods: {
    async editScheduledEntries(...entries) {
      this.entries = entries;

      for (const entry_data of this.entries) {
        if (entry_data.status === 'RAN') {
          alert('Past events with status "Complete" cannot be edited.');

          return false;
        }

        if (entry_data.service !== null) {
          alert('Events added from 3rd party cannot be edited.');

          return false;
        }
      }

      const modal_response = await this.fireModal('edit-scheduled-entries');
      const job_ids = entries.map(entry => entry.job_id);

      if (!modal_response.data.confirm) {
        return false;
      }

      const modal_response_data = await modal_response.data;
      let changes = 0;

      const post_data = {};
      if (modal_response_data.showname) {
        post_data.showname = modal_response_data.showname;
        changes++;
      }

      if (modal_response_data.description) {
        post_data.description = modal_response_data.description;
        changes++;
      }

      if (modal_response_data.tags) {
        post_data.tags = modal_response_data.tags.join();
        changes++;
      }

      if (modal_response_data.image) {
        post_data.image = modal_response_data.image;
        changes++;
      }

      if (modal_response_data.broadcaststart) {
        post_data.broadcaststart = modal_response_data.broadcaststart;
        changes++;
      }

      if (modal_response_data.broadcastend) {
        post_data.broadcastend = modal_response_data.broadcastend;
        changes++;
      }

      if (modal_response_data.duration) {
        post_data.duration = modal_response_data.duration;
        changes++;
      }

      if (modal_response_data.freq) {
        post_data.freq = modal_response_data.freq;
        changes++;
      }

      if (modal_response_data['weekly-day']) {
        post_data['weekly-day'] = modal_response_data['weekly-day'];
        changes++;
      }

      if (modal_response_data.ttype) {
        post_data.ttype = modal_response_data.ttype;
        changes++;
      }

      if (modal_response_data.publishstart) {
        post_data.publishstart = modal_response_data.publishstart;
        changes++;
      }

      if (modal_response_data.publishstop) {
        post_data.publishstop = modal_response_data.publishstop;
        changes++;
      }

      if (modal_response_data.publishduration) {
        post_data.publishduration = modal_response_data.publishduration;
        changes++;
      }

      if (modal_response_data.publishdelay) {
        post_data.publishdelay = modal_response_data.publishdelay;
        changes++;
      }

      if (modal_response_data.streamname) {
        post_data.streamname = modal_response_data.streamname;
        changes++;
      }

      if (modal_response_data.startsat) {
        post_data.startsat = modal_response_data.startsat;
        changes++;
      }

      if (modal_response_data.endsat) {
        post_data.endsat = modal_response_data.endsat;
        changes++;
      }

      if (this.entries[0].timezone !== modal_response_data.timezone) {
        post_data.timezone = modal_response_data.timezone;
        changes++;
      }

      if (changes > 0) {
        post_data.status = "NEW";

        try {
          const edit_response = await axios.post('/api/v1/scheduler/edit',
            {
              job_ids,
              payload: post_data,
            },
          );

          return edit_response;
        } catch (error) {
          toastr.error(error?.response?.data?.error?.message ?? error?.message ?? "Something went wrong");
        }
      }

      return;
    },
  },
};
